import { useScheduleJobMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useScheduleJob() {
  const [mutation, { loading, data, error }] = useScheduleJobMutation({
    refetchQueries: [
      "customGetJobSchedules",
      "getJobSchedules",
      "getJobScheduleStats",
      "customGetJobs",
      "getJobs",
    ],
  });

  const [scheduleJob, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "scheduleJob",
    },
    {
      hideMessage: true,
    }
  );

  return [scheduleJob, context] as const;
}
